var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{style:(_vm.wallpapers[Math.floor(Math.random() * _vm.wallpapers.length)]),attrs:{"id":"main"}},[_c('div',{staticClass:"bg-overlay"},[_c('router-view')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }